var TscAvatarSize = {
  small: 'small',
  medium: 'medium',
  mediumLarge: 'mediumLarge',
  large: 'large'
};
export default TscAvatarSize;